import { SVGProps } from "react";

export function Auth0(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      fill="none"
      viewBox="0 0 41 40"
      {...props}
    >
      <path
        fill="#000"
        d="M7.436 18.013c6.012-.99 10.721-5.96 11.711-11.967l.332-2.89c.08-.46-.229-1.096-.81-1.052-4.543.353-8.825 1.851-11.214 2.827A3.145 3.145 0 0 0 5.5 7.842v9.424c0 .56.5.983 1.053.894l.883-.143zM22.046 6.05c.99 6.01 5.7 10.977 11.711 11.967l.884.143a.905.905 0 0 0 1.052-.894V7.842a3.15 3.15 0 0 0-1.954-2.911c-2.386-.976-6.671-2.474-11.214-2.827-.582-.044-.884.6-.814 1.052l.331 2.89zM33.753 20.654c-8.213 1.62-12.027 7.079-12.027 17.415 0 .519.515.876.946.589 3.777-2.547 12.09-9.196 12.948-17.514.033-1.05-1.278-.556-1.867-.49M7.439 20.658c8.213 1.62 12.027 7.078 12.027 17.415 0 .519-.515.876-.946.589-3.777-2.548-12.09-9.196-12.948-17.515-.033-1.049 1.278-.555 1.867-.49"
      ></path>
    </svg>
  );
}
